module.exports = "/images/logo-inverse.png?37e63268baddec09064a38a2c552297d";